import styled from "styled-components";

interface ContentStockProps {
  fontSize?: number;
  fontWeight?: string;
  paddingTop?: number;
  lineHeight?: number;
}

export const ContainerHeader = styled.div`
  width: 100%;
  padding: 10px;
  margin-bottom: 10px;
`;

export const TitleStock = styled.h2`
  font-size: 24px;
  padding: 0;
  margin: 0 0 0 6px;
`;

export const NoStockExists = styled.div`
  width: 100%;
  text-align: center;
  border-top-left-radius: 18px;
  border-bottom-left-radius: 18px;
  text-align: center;
  border: 0;
  color: #837775;
  font-size: 16px;
  background: #ece9e9;
  display: block;
  padding: 15px;
  box-sizing: border-box;
  border-radius: 18px;
`;

export const Box = styled.div`
  width: 100%;
  min-height: 116px;
  background: #ECE9E9;
  border-radius: 10px;
  box-sizing: border-box;
  display: flex;
  color: #1A1D28;
  cursor: pointer;
  transition: .3s all;
  box-sizing: border-box;

  &:hover {
    background: #d9d4d4;
  }

  @media (max-width: 1227px) {
    min-height: 160px;
  }

  @media (max-width: 1000px) {
    min-height: 157px;
  }

  @media (max-width: 960px) {
    min-height: 175px;
  }

  @media (max-width: 933px) {
    min-height: 234px;
  }

  @media (max-width: 800px) {
    min-height: 183px;
  }

  @media (max-width: 500px) {
    min-height: 76px;
  }
`;

export const Title = styled.div`
  font-weight:${(props: ContentStockProps) => `${props.fontWeight || 'regular'}`};
  font-size: ${(props: ContentStockProps) => `${props.fontSize || 14}px`};
  padding-top: ${(props: ContentStockProps) => `${props.paddingTop || 0}px`};
  line-height: ${(props: ContentStockProps) => `${props.lineHeight || 23}px`};
  display: flex;
  align-items: center;
  align-self: center;
  box-sizing: border-box;
`;

export const BoxTexts = styled.div`
  padding: 15px;
  flex: 1;
  box-sizing: border-box;
`;

export const BoxQuantitys = styled.div`
  width: 72px;
  background: rgba(26, 29, 40, 0.1);
  border-radius: 10px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .quantity {
    font-size: 10px;
  }

  .price {
    font-size: 18px;
    line-height: 23px;
    font-weight: 800;
  }
`;

export const CdBoxContentContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-content: flex-start;
`;

export const CdBoxContent = styled.div`
  background: #ECE9E9;
  display: flex;
  justify-content: space-between;
  border-radius: 8px;
  overflow: hidden;
  align-items: center;
  margin-top: 10px;
`;

export const IconBox = styled.div`
  background: rgba(0,0,0, 0.15);
  padding: 10px 15px 3px 15px;

  img {
    width: 25px;
  }
`;

export const TextContent = styled.div`
  text-align: center;
  width: 100%;
  font-weight: 500;
  padding: 0px 20px;
  text-transform: uppercase;
`;

